module.exports = __webpack_public_path__ + "static/img/repast02.9a739ce7.jpg";